import type { LvArt, LvZuordnung } from '../api/project-lv.api'

/** AP-35 Blatt 12 — Beschriftungen des LV im Projekt. */
export const LV_PHASE: Record<string, string> = { TENDER: 'Ausschreibung', OFFER: 'Angebot', ORDER: 'Auftrag', OTHER: '—' }

export const LV_ART: Record<LvArt, string> = { NORMAL: '', OPTIONAL: 'Eventual', ALTERNATIVE: 'Wahl', REGIE: 'Regie', SURCHARGE: 'Zuschlag', TEXT: 'Text' }

export const LV_ZUORDNUNG: Record<LvZuordnung, { label: string; klasse: string }> = {
  ASSIGNED: { label: 'zugeordnet', klasse: 'text-foreground' },
  PARTIAL: { label: 'teilweise', klasse: 'text-amber-700 dark:text-amber-400' },
  OVER: { label: 'mehrfach', klasse: 'text-destructive' },
  NONE: { label: 'nicht zugeordnet', klasse: 'text-muted-foreground' },
  TEXT: { label: 'Text', klasse: 'text-muted-foreground' },
}

export const LV_FELD: Record<string, string> = { quantity: 'Menge', unit: 'Einheit', shortText: 'Kurztext', longText: 'Langtext', kind: 'Art', unitPrice: 'Preis' }

/** Hinweise beim Einfügen aus dem LV (Blatt 12 8.). */
export const LV_HINWEIS: Record<string, string> = {
  LV_UNIT_UNKNOWN: 'Einheit ohne Übersetzung',
  LV_PRICES_HIDDEN: 'Preis aus dem LV wird übernommen, nicht angezeigt',
  LV_ITEM_OVERASSIGNED: 'mehrfach zugeordnet',
  LV_SURCHARGE_WITHOUT_PARENT: 'Zuschlag ohne Bezugsposition — eigene Zeile',
  LV_ITEM_REGIE: 'Regieposition',
  LV_ITEM_OPTIONAL: 'Eventual/Wahl — nicht verrechenbar',
}

export const lvMenge = (n: number | null | undefined) => (n === null || n === undefined ? '' : n.toLocaleString('de-DE', { maximumFractionDigits: 3 }))
export const lvWert = (v: unknown) => (v === null || v === undefined || v === '' ? '—' : typeof v === 'number' ? lvMenge(v) : String(v).slice(0, 40))
